var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle53BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M40.003 37.5a1.5 1.5 0 0 1-1.5 1.5h-31a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h31a1.5 1.5 0 0 1 1.5 1.5v15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28 6h10l.752 8.274A2.5 2.5 0 0 1 36.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L28 6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m27 8 .223-.445A2.813 2.813 0 0 1 29.738 6h6.524c1.065 0 2.039.602 2.515 1.555L39 8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18 54H8l-.752-8.274A2.5 2.5 0 0 1 9.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L18 54Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m19 52-.223.445A2.813 2.813 0 0 1 16.262 54H9.738a2.813 2.813 0 0 1-2.515-1.555L7 52"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M8 6h10l.752 8.274A2.5 2.5 0 0 1 16.262 17H9.738a2.5 2.5 0 0 1-2.49-2.726L8 6Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m7 8 .223-.445A2.813 2.813 0 0 1 9.738 6h6.524c1.065 0 2.039.602 2.515 1.555L19 8"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M38 54H28l-.752-8.274A2.5 2.5 0 0 1 29.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L38 54Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m39 52-.223.445A2.813 2.813 0 0 1 36.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L27 52"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M55 25v10l-8.274.752A2.5 2.5 0 0 1 44 33.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L55 25Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m53 24 .445.223A2.813 2.813 0 0 1 55 26.738v6.524c0 1.065-.602 2.039-1.555 2.515L53 36"
})));
SvgRectangle53BSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle53BSelected);
export default ForwardRef;